import React, { useState } from 'preact/compat'
import { useEffect } from 'react'

const HtmlContainer = ({ area, isHidden, endOn, onEvent }) => {
  const [html] = useState(area.data.html)

  useEffect(() => {
    const durationDelay = parseInt(endOn?.delay ?? 60) * 1000

    const event = setTimeout(() => {
      onEvent('end')
    }, durationDelay)

    return () => clearTimeout(event)
  })

  return (
    <div
      style={{ width: '100%', height: '100%' }}
      className={!isHidden ? 'has-animations' : ''}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}

export default React.memo(HtmlContainer, (props, nextProps) => {
  return (
    props.area?.id === nextProps.area?.id &&
    props.isHidden === nextProps.isHidden &&
    props.area?.uniqId === nextProps.area?.uniqId
  )
})
